/**
 * 값 → 선택된 탭의 index.
 *
 * `ContentTab` 의 유일한 로직이다. 나머지는 마크업이라 여기만 테스트한다.
 * 호출부가 index(`0 | 1`)를 값으로 쓰는 곳이 있어(WorkSNB 두 곳) **`0` 이 falsy 라는 것**이
 * 이 함수를 쓰는 쪽의 함정이다. 반환값은 `if (idx)` 가 아니라 `idx >= 0` 으로 판정한다.
 *
 * @returns 없으면 `-1`
 */
export function getSelectedIndex<T>(
  items: readonly { value: T }[],
  value: T,
): number {
  return items.findIndex((item) => item.value === value);
}
